<template>
    <b-input-group :id="id" :readonly="readonly" :disabled="disabled" class="e-input-birthday">
        <b-input-group-text v-if="showCake">
            <i class="fas fa-birthday-cake"></i>
        </b-input-group-text>
        <b-select v-model="day" :options="days" :autofocus="autofocus" @change="changed"
                  name="day" :required="required" :readonly="readonly">
            <option disabled :value="null" v-tr>Day|Jour</option>
        </b-select>
        <b-select v-model="month" :options="months" @change="changed"
                   name="month" :required="required" :readonly="readonly">
            <option disabled :value="null" v-tr>Month|Mois</option>
        </b-select>
        <b-select v-model="year" :options="years" @change="changed"
                  name="year" :required="required" :readonly="readonly">
            <option disabled :value="null" v-tr>Year|Année</option>
        </b-select>
    </b-input-group>
</template>

<script>

    export default {
        name: `e-input-birthday`,
        props: {
            id: {type: String},
            name: {type: String},
            disabled: {type: [Boolean, String]},
            required: {type: Boolean, default: false},
            autofocus: {type: Boolean, default: false},
            showCake: {type: Boolean},
            size: {type: String, default: `md`},
            state: {type: [Boolean, String], default: null},
            value: {type: String, default: ``},
            readonly: {type: Boolean, default: false}
        },
        data() {
            return {
                internalValue: null,
                day: null,
                month: null,
                year: null,
                disableWatcher: false
            }
        },
        computed: {
            days() {
                let days = [];
                for (let i = 1; i <= 31; i++) {
                    days.push(i);
                }
                return days;
            },
            months() {
                let months = [];
                for (let i = 0; i < 12; i++) {
                    months.push({
                        value: i,
                        text: this.$moment().month(i).format(`MMMM`)
                    });
                }
                return months;
            },
            years() {
                let years = [];
                const start = this.$moment().year();
                for (let i = start - 120; i < start; i++) {
                    years.push(i);
                }
                return years;
            },
            birthday() {
                return `${this.year}-${fillIntegerWithZero(this.month + 1)}-${fillIntegerWithZero(this.day)}`;
            }
        },
        mounted() {
            this.internalValue = this.value;
            this.parseValue();
        },
        methods: {
            focus() {
                this.$refs.input.focus();
            },
            select() {
                this.$refs.input.select();
            },
            changed() {
                this.disableWatcher = true;
                this.$emit(`input`, this.birthday);
            },
            parseValue() {
                const date = this.$moment.utc(this.value);
                if (date._isValid) {
                    this.year = date.year();
                    this.month = date.month();
                    this.day = date.date();
                } else {
                    this.year = null;
                    this.month = null;
                    this.day = null;
                }
            }
        },
        watch: {
            value() {
                // Small optimization
                if (!this.disableWatcher) {
                    this.internalValue = this.value;
                    this.parseValue();
                }
                this.disableWatcher = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
